<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div class="text-xs-center">
			<v-dialog v-model="modal" persistent width="1000">
				<v-card>
					<v-card-title class="headline accent" primary-title>
						Eksport ofert
					</v-card-title>

					<v-card-text>
						<v-form ref="form">
							<v-flex d-flex>
								<v-autocomplete label="Wybierz pole" :item-text="getFieldName" item-value="id" aria-label="field"
									v-model="selectedFieldId" :items="fields" :menu-props="{
										maxWidth: 650,
										minWidth: 650,
									}">
									<template v-slot:item="{ item }">
										<span :class="{
											'primary--text': item.generic,
											'font-weight-bold': isFieldExpandable(item),
											'font-italic': isTableField(item)
										}">
											{{ getFieldName(item) }}
										</span>
									</template>
								</v-autocomplete>
								<v-btn style="flex: none !important;" color="primary" @click="addAllFields">
									Dodaj wszystkie pola
								</v-btn>
								<v-btn style="flex: none !important;" color="primary" @click="resetFields">
									Resetuj
								</v-btn>
							</v-flex>
							<v-flex v-if="selectedFieldId">
								<v-divider />
								<v-container>
									{{ selectedFieldName }}
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon color="success" @click="acceptChosenField">
												<v-icon v-on="on" class="white-icon">done</v-icon>
											</v-btn>
										</template>
										<span>Dodaj</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon color="red" @click="cancelChosenField">
												<v-icon v-on="on" class="white-icon">close</v-icon>
											</v-btn>
										</template>
										<span>Usuń</span>
									</v-tooltip>
								</v-container>
								<v-divider />
							</v-flex>
							<export-field-list v-model="chosenFields" />
						</v-form>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue" @click="closeModal">
							Anuluj
						</v-btn>
						<v-btn color="primary" @click="exportOffers">
							Eksportuj
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</div>
</template>

<script>
import { Api } from "@/api";
import { PublicContest } from "@/api/generated/PublicContest";
import { genericFormUtil } from "@/utils/genericFormUtil";
import { Files } from "@/utils/Files";
import ExportFieldList from "@/view/logged/offer/components/ExportFieldList";
import { isExpandableFieldCode } from "@/utils/ExportFieldUtils";

export default {
	name: "OfferExportModal",
	components: { ExportFieldList },
	mixins: [Files],

	data() {
		return {
			exportData: [],
			modal: false,
			contestId: this.$route.params.id,
			contestData: null,
			fields: [],
			selectedFieldId: null,
			chosenFields: [],
			constantFields: [],
		};
	},

	computed: {
		selectedFieldName() {
    		const field = this.fields.find(field => field.id === this.selectedFieldId);
    		return this.getFieldName(field);
		}
	},

	methods: {
		acceptChosenField() {
			let field = this.fields.find(field => {
				return field.id === this.selectedFieldId;
			});
			this.chosenFields.push(JSON.parse(JSON.stringify(field)));
			this.selectedFieldId = null;
		},

		cancelChosenField() {
			this.selectedFieldId = null;
		},

		getFieldName(item) {
			if (!item || !item.name) return 'Pole bez nazwy';
			return item.business === 'TABLE' ? item.name + ' (tabela)' : item.name;
		},

		isTableField(item) {
			return item && item.business === 'TABLE';
		},

		isFieldExpandable(item) {
			if (!item) return false;
			const { code } = item;
			return isExpandableFieldCode(code);
		},

		exportOffers() {
			PublicContest.postOfferExport(this, this.contestId, {
				fields: this.chosenFields,
				offerCodes: this.searchParams.offerCodes,
			},
				success => {
					let filename = "eksport_ofert.xlsx";
					this.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
						success);
					Files.methods.downloadBlobResponse(success, filename);
				},
				error => this.$messagesBus.$emit("error", "Eksport nieudany", error),
				{
					responseType: "blob",
				}
			);
			this.closeModal();
		},

		closeModal() {
			this.modal = false;
		},

		addAllFields() {
			this.resetFields();
			this.chosenFields.push(...this.fields);
		},

		resetFields() {
			this.selectedFieldId = null;
			this.chosenFields.splice(0, this.chosenFields.length);
		},

		async openModal(searchParams, contestId = this.contestId) {
		this.contestId = contestId;
			await this.loadGenericSchema();
			this.modal = true;
			this.searchParams = { offerCodes: searchParams };
			await this.initializeFields();
		},

		async initializeFields() {
			await this.loadConstantFields();
			this.fields = this.constantFields;
			if (this.contestData.modular) {
				this.fields.push(...genericFormUtil.getListOfAllModuleFields(genericFormUtil.decodeSchema(this.contestData.moduleSchema), this.contestData.maxModuleNumber));
			}
			this.fields.push(...genericFormUtil.getListOfAllPersistentFields(genericFormUtil.decodeSchema(this.contestData.persistentSchema)));
		},

		async loadGenericSchema() {
			await Api.syncGet(this, "/public-contest/data-required-to-export?contestId=" + this.contestId,
				success => {
					this.contestData = success;
				},
				error => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać wszystkich pól do eksportu", error);
				});
		},

		async loadConstantFields() {
			await Api.syncGet(this, "/public-contest/offer-constant-fields?contestId=" + this.contestId,
				success => {
					this.constantFields = success;
				},
				error => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać wszystkich pól do eksportu", error);
				});
		}
	},
};
</script>

<style scoped>
.white-icon {
	color: white !important;
}
</style>
